var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"wish-info",attrs:{"to":{name: 'ViewProducts', params: {id: _vm.product.id}}}},[_c('div',[_vm._v(" "+_vm._s(_vm.product.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }